import { ErrorCodeDisplay } from '@ingeniorforeningen/figurine-core';
import { useEffect } from 'react';
import { trackError } from '../tracking';

export default function NotFoundPage() {
  const error = new Error('Page not found');

  useEffect(() => {
    trackError(error, 404);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ErrorCodeDisplay code="404" my="xl" />;
}
